import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/components/card';
import CardHeader from 'common/components/card-header';
import CardContent from 'common/components/card-content';
import {Table, Column, Row} from 'common/components/table';
import Tooltip from 'common/components/tooltip';
import SvgSymbol from 'common/components/svg-symbol';
import * as ResourceIconUtil from 'common/utils/resource-icon-util';
import {t} from 'common/utils/translation-util';

import './index.scss';

export default class TenantConsumptionCostCard extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func,
    disableConfig: PropTypes.bool,
    report: PropTypes.object.isRequired,
    tenantId: PropTypes.number,
  };

  static defaultProps = {
    connectDragSource: (x) => x,
    disableConfig: false,
    tenantId: null,
  };

  constructor(props, context) {
    super(props, context);
    this.toggleCostTooltip = this.toggleCostTooltip.bind(this);
    this.toggleRateTooltip = this.toggleRateTooltip.bind(this);
    this.state = {
      ...this.getStateFromReportProp(),
      loading: false,
      costTooltipVisible: false,
      rateTooltipVisible: false,
    };
  }

  getStateFromReportProp() {
    const tenant = this.props.report.data;
    tenant.totalCost = tenant.summary && tenant.summary.totalCost;
    return tenant;
  }

  toggleCostTooltip() {
    this.setState({
      costTooltipVisible: !this.state.costTooltipVisible,
    });
  }

  toggleRateTooltip() {
    this.setState({
      rateTooltipVisible: !this.state.rateTooltipVisible,
    });
  }

  render() {
    const {connectDragSource, disableConfig} = this.props;

    const headerTitle = this.props.report.data.title;

    const header = connectDragSource(
      <div>
        <CardHeader
          disableConfig={disableConfig}
          priorityWarnings={this.props.report.priorityWarnings}
          reportId={this.props.report.id}
          subtitle={
            this.props.report.meta && this.props.report.meta.period.displayName
          }
          title={headerTitle}
          warnings={this.props.report.warnings}
        />
      </div>,
    );

    const tableHeaders = [
      t('Building Space'),
      t('Resource'),
      t('Consumption'),
      <div
        className={'TenantConsumptionCostCard-Tooltip-container'}
        key={'rate'}>
        {'Rates'}
        <span
          onMouseEnter={this.toggleRateTooltip}
          onMouseLeave={this.toggleRateTooltip}>
          <SvgSymbol
            className={'TenantConsumptionCostCard-Tooltip-icon'}
            name={'tool-tip'}
          />
          <span style={{left: '-14px', top: '-2px', position: 'relative'}}>
            <Tooltip absolute={true} visible={this.state.rateTooltipVisible}>
              {t(
                'Rate represents the price of consumption for this point. Click ' +
                  'the rate hyperlink to see more details or to edit the pricing schedule.',
              )}
            </Tooltip>
          </span>
        </span>
      </div>,
      <div
        className={'TenantConsumptionCostCard-Tooltip-container'}
        key={'cost'}>
        {t('Cost')}
        <span
          onMouseEnter={this.toggleCostTooltip}
          onMouseLeave={this.toggleCostTooltip}>
          <SvgSymbol
            className={'TenantConsumptionCostCard-Tooltip-icon'}
            name={'tool-tip'}
          />
          <span style={{left: '-14px', top: '-2px', position: 'relative'}}>
            <Tooltip absolute={true} visible={this.state.costTooltipVisible}>
              {t(
                'Cost represents an estimated cost of consumption from the Utility Rate Engine.',
              )}
            </Tooltip>
          </span>
        </span>
      </div>,
    ];

    const rows = this.state.results.map((result, index) => {
      /* eslint-disable import/namespace */
      return [
        <a href={result.spaceAssignmentUrl} key={index}>
          {result.space}
        </a>,
        <div key={index}>
          <SvgSymbol name={ResourceIconUtil[result.resource.slug]} />
          <span className={'TenantConsumptionCostCard-resource-text'}>
            {result.resource.displayName}
          </span>
        </div>,
        result.consumption,
        <div key={index}>
          {result.rates.map((rateObj, rateIndex) => (
            <div key={`rate ${rateIndex}`}>
              <a href={rateObj.pricingScheduleUrl}>{rateObj.rate}</a>
            </div>
          ))}
        </div>,
        result.cost,
      ];
      /* eslint-enable import/namespace */
    });

    const summaryRow = [
      t('All Building Spaces'),
      null,
      null,
      null,
      this.state.totalCost,
    ];

    return (
      <Card
        className={'TenantConsumptionCostCard'}
        loading={this.state.loading}>
        {header}
        <CardContent>
          <div className={'TenantConsumptionCostCard-table-container'}>
            <Table
              style={{
                border: 'none',
                margin: '0px',
              }}
              summaryData={summaryRow}>
              {tableHeaders.map((datum, index) => (
                <Column key={index}>{datum}</Column>
              ))}
              {rows.map((datum, index) => (
                <Row data={datum} key={index} />
              ))}
            </Table>
          </div>
        </CardContent>
      </Card>
    );
  }
}
